export default "__VITE_ASSET___BWdVySl__"